export const ACTION_TYPES = {
  TOGGLE_THEME: "toggleTheme",
  INITIALISE_STORE: "initialiseStore",
  TOGGLE_LANGUAGE: "toggleLanguage",
  SET_ACTIVE_SLIDE: "setActiveSlide",
};
